import { render, staticRenderFns } from "./TrainingInfosForStudent.vue?vue&type=template&id=8f24cd8a"
import script from "./TrainingInfosForStudent.vue?vue&type=script&lang=js"
export * from "./TrainingInfosForStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports